class CartFreeGift extends HTMLElement {
    constructor() {
        super();
        this.giftThreshold = Number(this.getAttribute('gift-threshold'));
        this.partialMessage = this.getAttribute('partial-message') || '';
        this.successMessage = this.getAttribute('success-message') || '';
        this.giftProductVariantID = Number(this.getAttribute('variant-id')) || '';
        this.handleCartUpdate = this.handleCartUpdate.bind(this);
        this.reAddFreeGift = this.reAddFreeGift.bind(this);
        this.previousCart = null;
    }

    connectedCallback() {
        if (!this.hasInitialized) {
            this.initializeGiftProgressBar();
            window.addEventListener('cartUpdated', this.handleCartUpdate);

            // Assign handleGiftRemoval to a window function
            window.handleGiftRemoval = this.handleGiftRemoval.bind(this);

            // localStorage.removeItem('lemelGiftManuallyRemoved')

            this.hasInitialized = true;
        }
    }

    disconnectedCallback() {
        window.removeEventListener('cartUpdated', this.handleCartUpdate);
        delete window.handleGiftRemoval; // Clean up the global function
        this.hasInitialized = false;
    }

    initializeGiftProgressBar() {
        this.giftMessage = this.querySelector('.gift-banner-message');
        this.giftProgressBar = this.querySelector('.gift-progress-bar');
    }

    async handleCartUpdate(event) {
        const cart = event.detail;
        let totalAmount = cart.total_price;
        cart.items.forEach(item => {
            if (item.product_type.includes('Gift Card')) {
                totalAmount -= item.final_line_price;
            }
            if (item.properties["_free_gift"]) {
                totalAmount -= item.final_line_price;
            }
        });

        const meetsThreshold = totalAmount >= this.giftThreshold;
        const giftInCart = cart.items.some(item => item.variant_id === this.giftProductVariantID);
        this.previousCart = cart;

        if (meetsThreshold) {
            if (!giftInCart) {
                if (!localStorage.getItem('lemelGiftManuallyRemoved')) {
                    await this.addFreeGift();
                    if(document.querySelector("#shopping_cart .cart-item--free-gift") !== null){
                        document.querySelector("#shopping_cart .cart-item--free-gift").style.display = "table-row";
                    }   
                } else {
                    this.showReAddButton();
                }
                if(document.querySelector("#shopping_cart .cart-item--free-gift") !== null){
                    document.querySelector("#shopping_cart .cart-item--free-gift").style.display = "none";
                }                
            } else {
                if(document.querySelector("#shopping_cart .cart-item--free-gift") !== null){
                    document.querySelector("#shopping_cart .cart-item--free-gift").style.display = "table-row";
                }
            }
        } else if (giftInCart) {
            await this.removeGift();
            if(document.querySelector("#shopping_cart .cart-item--free-gift") !== null){
                document.querySelector("#shopping_cart .cart-item--free-gift").style.display = "none";
            }   
        }

        this.updateProgressBar(totalAmount);
    }

    async addFreeGift() {
        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: this.giftProductVariantID,
                        quantity: 1,
                        properties: { '_free_gift': true },
                    }]
                }),
            });
            updateCartStuff();
        } catch (error) {
            console.error('Error adding free gift:', error);
        }
    }

    async removeGift() {
        try {
            await this.cartItemUpdate(this.giftProductVariantID, 0);
            // localStorage.setItem('lemelGiftManuallyRemoved', 'false');
        } catch (error) {
            console.error('Error removing free gift:', error);
        }
    }

    async handleGiftRemoval(variantId) {
        if (variantId === this.giftProductVariantID) {
            localStorage.setItem('lemelGiftManuallyRemoved', 'true');
            await this.cartItemUpdate(variantId, 0);
        }
    }

    async cartItemUpdate(variantId, qty) {
        const itemUpdateData = `updates[${variantId}]=${qty}`;
        try {
            const response = await fetch(`/cart/update.js?${itemUpdateData}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });
            const data = await response.json();
            if (data.status === 422) {
                alert(data.message);
            }
            updateCartStuff();
        } catch (error) {
            console.error('Error updating cart item:', error);
        }
    }

    showReAddButton() {
        if (this.giftMessage) {
            setTimeout(() => {
                this.giftMessage.innerHTML = `
                    <button class="gift-re-add" onclick="document.querySelector('cart-free-gift').reAddFreeGift()">
                        Re-add your free gift
                    </button>
                `;
            }, 1);
        }
    }
 
    async reAddFreeGift() {
        localStorage.setItem('lemelGiftManuallyRemoved', 'false');
        await this.addFreeGift();
    }

    updateProgressBar(totalAmount) {
        const remainingAmount = this.giftThreshold - totalAmount;
        const percentage = Math.min((totalAmount / this.giftThreshold) * 100, 100);

        this.giftMessage.textContent = remainingAmount > 0
            ? this.partialMessage.replace('***', Shopify.formatMoney(remainingAmount).replace('.00', ''))
            : this.successMessage;

        this.giftProgressBar.style.width = `${percentage}%`;
    }

    refreshCart() {
        // updateCartStuff();
    }
}

if (!window.customElements.get('cart-free-gift')) {
    window.customElements.define('cart-free-gift', CartFreeGift);
}
